<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Objektų archyvas') }}</h1>
    <!-- search -->
    <admin-object-archive-search @downloadReport="downloadReport" :loading="loading" @search="searchObject" />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import AdminObjectArchiveSearch from './AdminObjectArchiveSearch'
import userRole from '@/mixins/userRole'
import tableParameters from '@/mixins/tableParameters'
import math from '@/mixins/math'

export default {
  name: 'ObjectArchive',
  components: {
    AdminObjectArchiveSearch,
  },
  mixins: [userRole, tableParameters, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Eil. Nr.'),
          align: 'start',
          sortable: false,
          value: 'number',
        },
        {
          text: this.$t('Objekto pavadinimas'),
          align: 'start',
          value: 'type',
        },
        {
          text: this.$t('Objekto identifikavimo kodas'),
          align: 'start',
          value: 'object_id',
        },
        {
          text: this.$t('Įregistravimo data'),
          align: 'start',
          value: 'registration_date_from',
        },
        {
          text: this.$t('Išregistravimo data'),
          align: 'start',
          value: 'registration_date_to',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {},
  created() {
    // this.setlistParams()
  },
  methods: {
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`object-archive/list`, data)
        .then((res) => {
          this.listData = res.data.objectArchive
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
        pageSize: pagination.itemsPerPage,
        page: pagination.page,
        route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchObject(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    downloadReport() {
      this.loading = true
      const data = {
        ...this.pagination,
        search: this.searchData,
        isReport: true,
      }
      this.$axios
        .post(`object-archive/list`, data)
        .then((res) => {
           this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
